import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ListSelector from '../../../../components/template/ListSelector';
import Modal from '../../../../components/template/Modal';
import ThresholdModal from './ThresholdModal';
import ThresholdNewModal from './ThresholdNewModal';
import api from '../../../../components/utils/api';

const ThresholdPage = () => {
    const { mergeRuleId } = useParams();
    const [thresholds, setThresholds] = useState([])
    const [selectedThreshold, setSelectedThreshold] = useState({})
    const [modalVisible, setModalVisible] = useState(false);
    const openModal = () => { setModalVisible(true); }
    const closeModal = () => { setModalVisible(false); }

    useEffect(() => {
        if (mergeRuleId) {
            api.get(`/api/merge-rules/${mergeRuleId}/thresholds`)
                .then(res => setThresholds(res.data.thresholds))
                .catch(err => console.error(err))
        }
    }, [mergeRuleId])

    return (
        <>
            <ListSelector
                obejcts={thresholds}
                selectedObject={selectedThreshold}
                onClick={(obj) => { setSelectedThreshold(obj); openModal() }}
                modalContents={<ThresholdNewModal mergeRuleId={mergeRuleId} thresholds={thresholds} />}
                addNewString={' Add a Threshold'}
            />
            {modalVisible && <Modal
                visible={modalVisible}
                closable={true}
                maskClosable={true}
                onClose={closeModal}>{
                    <ThresholdModal selectedThreshold={selectedThreshold} mergeRuleId={mergeRuleId} />
                }</Modal>}
        </>
    )
}

export default ThresholdPage